import { useFormik } from 'formik';
import React from 'react'
import * as Yup from 'yup'
import { Col, Container, Row } from 'react-bootstrap'
import { makeid } from '../helper/helper';
import { FaMapMarkerAlt } from 'react-icons/fa';
import { MdCall, MdEmail } from 'react-icons/md';

export default function ContactUs() {
    const phoneRegExp = /^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[789]\d{9}$/


    const formik = useFormik({
        initialValues: {
            full_name: "",
            email: "",
            contact_number: "",
            address: ""
        },
        validationSchema: Yup.object({
            full_name: Yup.string()
                .min(2, "Mininum 2 characters")
                .max(15, "Maximum 15 characters")
                .required("Required!"),
            email: Yup.string()
                .email("Invalid email format")
                .required("Required!"),
            contact_number: Yup.string().matches(phoneRegExp, 'Phone number is not valid')
                .required("Required!"),
            address: Yup.string()
                .required()
        }),
        onSubmit: values => {
            values.id = makeid(8)

            formik.resetForm()
        }
    });

    return (
        <Container id='contact'>
            <Row>
                <Col md={6} className='p-0'>
                    <iframe className='contact-frame' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3719.549498160876!2d72.86306807600188!3d21.21004798152593!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04f0cc7d9eebd%3A0x10e226155b585955!2sKrishna%20Handloom%20%26%20Curtains!5e0!3m2!1sen!2sin!4v1715085802892!5m2!1sen!2sin" frameBorder={0} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </Col>
                <Col md={6} className='p-0'>
                    <div className=" mb-5 mb-lg-0 p-0">
                        <div className="bg-light d-flex flex-column justify-content-center px-2 px-md-5" style={{ height: '400px' }}>
                            <div className="d-flex align-items-center mb-5">
                                <div className="btn-icon bg-primary primary-btn me-4 p-3 rounded">
                                    <a className="text-white" href="https://goo.gl/maps/tY68pnXuMjLQ1Jc19" target="_blank">
                                        <FaMapMarkerAlt className='text-white display-6' />
                                    </a>
                                </div>
                                <div className="mt-n1">
                                    <h4>Our Location</h4>
                                    <p className="m-0">  Shop-2, 346, Gayatri Society, L.H. Road, Kapodra , Surat - 395006</p>
                                </div>
                            </div>
                            <div className="d-flex align-items-center mb-5">
                                <div className="btn-icon bg-secondary secondary-btn me-4 p-3 rounded">
                                    <MdCall className='text-white display-6' />
                                </div>
                                <div className="mt-n1">
                                    <h4>Call Us</h4>
                                    <p className="m-0">+91 834 776 3858</p>
                                </div>
                            </div>
                            <div className="d-flex align-items-center">
                                <div className="btn-icon bg-warning me-4 p-3 rounded">
                                    <MdEmail className='text-white display-6' />
                                </div>
                                <div className="mt-n1">
                                    <h4>Email Us</h4>
                                    <p className="m-0 text-break"> vandankapopara2111@gmail.com</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>

            </Row>
        </Container>
    )
}
